import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseTextBox } from '../../controls/BaseTextBox';
import orderService from '../OrderService';
import { OrderTextBox } from '../OrderTextBox';
import { BaseCombobox } from '../../controls/BaseCombobox';

export class CustomerStepView extends Component {
    static displayName = CustomerStepView.name;
    constructor(props) {
        super(props);
        const { customerName, customerAge, isRegularCustomer, currentBrand, originalShellScanFileUpload, machineBodyNumber, communicateWithMatchMaker, enclosureDesignReference } = props.model;
        this.state = {
            options: [], uploading: false, customerName: customerName, customerAge: customerAge, isRegularCustomer: isRegularCustomer, currentBrand: currentBrand, machineBodyNumber: machineBodyNumber, originalShellScanFileUpload: originalShellScanFileUpload, communicateWithMatchMaker: communicateWithMatchMaker, enclosureDesignReference: enclosureDesignReference, brands: [{ name: '唯听', id: '唯听' }, { name: '科塞奇', id: '科塞奇' }, { name: '西嘉/西门子', id: '西嘉/西门子' }, { name: '力斯顿', id: '力斯顿' }, { name: '奥德声', id: '奥德声' }, { name: '惠耳', id: '惠耳' }, { name: '峰力', id: '峰力' }, { name: '奥迪康', id: '奥迪康' }, { name: '瑞声达', id: '瑞声达' }, { name: '斯达克', id: '斯达克' }, { name: '优利康', id: '优利康' }, { name: '丽声', id: '丽声' }, { name: '欧仕达', id: '欧仕达' }, { name: '康聆声', id: '康聆声' }, { name: '其它', id: '其它' }]
        };
        this.handleLeftChange = this.handleLeftChange.bind(this);
        this.handleRightChange = this.handleRightChange.bind(this);
        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (target.type === 'radio') {
            if (name === "enclosureDesignReference") {
                this.setState({
                    [name]: parseInt(value)
                });
            }
            else {
                this.setState({
                    [name]: value === "1" ? true : false
                });
            }
            if (name == "isRegularCustomer" && value == 0) {
                this.setState({
                    currentBrand: "-1",
                    machineBodyNumber: "",
                    originalShellScanFileUpload:false
                })
            }
        }
        else {
            this.setState({
                [name]: value
            });
        }
    }

    componentDidMount() {
        this._subscription = orderService.subscribe(() => this.orderCommitting());
        //this.populateProductBand();
        this.props.onRef(this);
    }

    orderCommitting() {
        orderService.updateCustomerInfo(this.state);
    }

    componentWillUnmount() {
        orderService.unsubscribe(this._subscription);
    }

    handleSelectChanged(e) {
        var handler = this.onSelectChanged;
        if (handler) {
            handler(e);
        }
    }

    handleLeftChange(e) {
        var handler = this.onLeftChanged;
        if (handler) {
            handler(e);
        }
    }

    handleRightChange(e) {
        var handler = this.onRightChanged;
        if (handler) {
            handler(e);
        }
    }
    CheckFieldRequiredInvalid(field) {

        let trimfield = !field ? '' : field.trim();
        if (trimfield === '') {
            return true;
        }
        return false;
    }

    validate() {
        if (this.CheckFieldRequiredInvalid(this.state.customerName)) {
            return { state: false, msg: "CustomerNameRequired" }
        }

        if (!/^\d*$/.test(this.state.customerAge) || this.state.customerAge <= 0) {
            return { state: false, msg: "CustomerAgeRequiredIngeter" }
        }

        if (this.state.isRegularCustomer && this.CheckFieldRequiredInvalid(this.state.machineBodyNumber)) {
            return { state: false, msg: "MachineBodyNumberRequired" }
        }
        return { state: true }
    }
    render() {
        let items = this.props.items;
        if (!items) {
            items = new Array();

        }
        var clsName = this.state.isRegularCustomer ? "" : "text-gray-400 bg-gray-200"

        return (
            <div className="grid grid-cols-6 gap-6 w-1/2">
                <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="CustomerName" /><span className="font-bold text-red-600">*</span></label>
                    <BaseTextBox classnames="mt-1" type="text" name="customerName" value={this.state.customerName ?? ""} onChange={this.handleInputChange} />
                </div>
                <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="CustomerAge" /></label>
                    <BaseTextBox classnames="mt-1" type="text" name="customerAge" value={this.state.customerAge ?? ""} onChange={this.handleInputChange} />
                </div>
                <div className="col-span-6 sm:col-span-3  self-end">
                    <label className="text-sm font-medium text-gray-900"><FormattedMessage id="IsRegularCustomer" />
                        <span className="text-red-500">(<FormattedMessage id="RequiredForRegularCustomer2" />)</span>
                    </label>
                    <div className="flex gap-6 mt-1">
                        <label className="inline-flex items-center">
                            <input type="radio" name="isRegularCustomer" value="1" checked={this.state.isRegularCustomer === true} onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="Yes" /></span>
                        </label>
                        <label className="inline-flex items-center" >
                            <input className="ml-1" type="radio" name="isRegularCustomer" value="0" checked={this.state.isRegularCustomer === false} onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="No" /></span>
                        </label>
                    </div>
                </div>
                <div className="col-span-6 sm:col-span-3  self-end">
                    <label className="text-sm font-medium text-gray-900"><FormattedMessage id="CommunicateWithMatchMaker" /></label>
                    <div className="flex gap-6 mt-1">
                        <label className="inline-flex items-center">
                            <input type="radio" type="radio" name="communicateWithMatchMaker" value="1" onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="Yes" /></span>
                        </label>
                        <label className="inline-flex items-center">
                            <input type="radio" name="communicateWithMatchMaker" value="0" onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="No" /></span>
                        </label>
                    </div>
                </div>
                <div className="col-span-6 sm:col-span-3 self-end">
                    <label className="block text-sm font-medium text-gray-700" ><FormattedMessage id="CurrentBrand" /></label>
                    {/*   <BaseTextBox classnames="mt-1" type="text" name="currentBrand" value={this.state.currentBrand ?? ""} onChange={this.handleInputChange} />*/}
                    <BaseCombobox classnames={clsName} name="currentBrand" disabled={this.state.isRegularCustomer == true ? "" : "disabled"} value={this.state.currentBrand ?? ""} onChange={this.handleInputChange} >
                        <FormattedMessage id="PickOne" >
                            {text => <option value="-1">{text}</option>}
                        </FormattedMessage>
                        {this.state.brands.map((i, index) => <option key={index} value={i.id}>{i.name}</option>)}
                    </BaseCombobox>
                </div>
                <div className="col-span-6 sm:col-span-3 self-end">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="MachineBodyNumber" /></label>
                    <BaseTextBox classnames={clsName} type="text" disabled={this.state.isRegularCustomer == true ? "" : "disabled"} name="machineBodyNumber" value={this.state.machineBodyNumber ?? ""} onChange={this.handleInputChange} />
                </div>
                <div className="col-span-6">
                    <label className="text-sm font-medium text-gray-900"><FormattedMessage id="OriginalShellScanFileUpload" /><span className="text-red-500"><FormattedMessage id="OriginalShellScanFileUploadNote" /></span></label>
                    <div className="flex gap-6 mt-1">
                        <label className="inline-flex items-center">
                            <input disabled={this.state.isRegularCustomer == true ? "" : "disabled"} className={clsName} type="radio" type="radio" name="originalShellScanFileUpload" value="1" checked={this.state.originalShellScanFileUpload === true && this.state.isRegularCustomer == true} onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="Yes" /></span>
                        </label>
                        <label className="inline-flex items-center">
                            <input disabled={this.state.isRegularCustomer == true ? "" : "disabled"} className={clsName} type="radio" name="originalShellScanFileUpload" value="0" checked={this.state.originalShellScanFileUpload === false && this.state.isRegularCustomer == true} onChange={this.handleInputChange} />
                            <span class="ml-1"><FormattedMessage id="No" /></span>
                        </label>
                    </div>
                </div>
                <div className="col-span-6">
                    <lable className="text-sm font-medium text-gray-900">
                        <FormattedMessage id="EnclosureDesignReference" />
                    </lable>
                    <div className="flex gap-6 mt-1">
                        <label className="text-sm inline-flex items-center">
                            <input disabled={this.state.originalShellScanFileUpload == true ? "" : "disabled"} className={this.state.isRegularCustomer === true && this.state.originalShellScanFileUpload ? "" : "text-gray-400 bg-gray-200"} type="radio" name="enclosureDesignReference" value="0" checked={this.state.isRegularCustomer === true && this.state.enclosureDesignReference === 0 && this.state.originalShellScanFileUpload == true} onChange={this.handleInputChange} />
                            <span className="ml-1"><FormattedMessage id="CopyOriginal" /><span className="text-red-500"><FormattedMessage id="EnclosureDesignReferenceNote1" /></span></span>
                        </label>
                        <label className="text-sm inline-flex items-center">
                            <input disabled={this.state.originalShellScanFileUpload == true ? "" : "disabled"} className={this.state.isRegularCustomer === true && this.state.originalShellScanFileUpload ? "" : "text-gray-400 bg-gray-200"} type="radio" name="enclosureDesignReference" value="1" checked={this.state.isRegularCustomer === true && this.state.enclosureDesignReference === 1 && this.state.originalShellScanFileUpload == true} onChange={this.handleInputChange} />
                            <span className="ml-1"><FormattedMessage id="ReferenceProduction" /><span className="text-red-500"><FormattedMessage id="EnclosureDesignReferenceNote2" /></span></span>
                        </label>
                    </div>
                </div>
            </div>


        );
    }
}